import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { trpcClient } from "@/lib/trpc";
import VendorForm, { type VendorFormData } from "./VendorForm";
import { toast } from "sonner";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";

export default function VendorCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSubmit = async (data: VendorFormData) => {
    try {
      await trpcClient.vendors.create.mutate(data as any);

      await queryClient.invalidateQueries({ queryKey: ["vendors"] });
      navigate({ to: "/vendors" });
    } catch (err: any) {
      toast.error(err?.message || "Thêm nhà gia công thất bại");
    }
  };

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Nhà Gia Công", to: "/vendors" },
        { label: "Tạo mới" },
      ]}
      title="Thêm mới Nhà Gia Công"
      onBack={() => navigate({ to: "/vendors" })}
      showContextPanel={false}
    >
      <div className="w-full p-4 animate-in fade-in duration-300">
        <VendorForm
          onSubmit={handleSubmit}
          onCancel={() => navigate({ to: "/vendors" })}
          submitLabel="Tạo mới"
        />
      </div>
    </StandardDetailLayout>
  );
}
